<template lang="pug">
div
  el-row
    el-col(:sm="24")
      p.info Data da emissão:
        span {{ documento.dataEmissao }}
    el-col(:sm="24")
      p.info Número do processo:
        span {{ documento.numeroProcesso }}
    el-col(:sm="24")
      p.info Nome/Razão social do interessado:
        span {{ documento.nomeRazaoSocialDoInteressado }}
    el-col(:sm="24")
      p.info Protocolo:
        span {{ documento.protocolo }}
    el-col(:sm="24")
      p.info Número do título/certidão:
        span {{ documento.numeroTituloCertidao }}
    slot(name="validacao_assinatura")
    slot(name="baixar")

  el-row.dados-doc(v-if="!documento.tituloCancelado")
    .link-download
      font-awesome-icon(icon="link")
      a(href="https://validar.iti.gov.br/" target="_blank") &nbsp Link para validação da assinatura
    .link-download
      font-awesome-icon(icon="cloud-download-alt")
      a(@click="downloadDoc()") &nbsp Baixar Documento
  el-row(v-else)
    p.info-red Título cancelado!
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import _ from 'lodash'

export default {
  mixins: [
    AppNotificacao
  ],
  async created () {
    if (_.isEmpty(this.documento)) {
      await this.consultaDocumento(this.$route.params.protocolo)
    }
  },
  computed: {
    ...mapGetters({
      documento: 'documentosAutenticaveis/item'
    })
  },

  methods: {
    ...mapActions({
      consultaDocumento: 'documentosAutenticaveis/consultaAutenticidade',
      baixarDocumento: 'documentosAutenticaveis/download'
    }),
    downloadDoc () {
      this.baixarDocumento(this.documento.id)
    }
  }

}
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/_variables.scss";
$color-disable: #d0d0d0f7;
.info {
  font-weight: bold;
  font-size: 16px;
  margin: 10px 0 5px 0;
}
.title {
  font-size: 25px;
}
span {
  font-weight: normal;
  margin-left: 5px;
}

.dados-doc {
  overflow: auto;
  margin: 10px;
}

.link-download, a {
  margin-top: 15px;
  color: $color-primary;
  cursor: pointer;
  text-decoration: none;
  &:hover {
    color: #33b281;
  }
}

.info-red  {
  font-weight: bold;
  color: #ce2b2b !important;
  font-size: 24px;
  margin: 10px 0 5px 0;
}
</style>



// WEBPACK FOOTER //
// src/screens/portal/publico/TituloCertidao.vue